module.exports = __webpack_public_path__ + "img/Hypoxia-LICA_GSE236681.f189ea5b.png";